import React, { useEffect, useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
// import { useDispatch } from 'react-redux';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
// import { push } from 'connected-react-router';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
// import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import './ManageClientBilling.scss';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import { AnyObject } from 'final-form';
import ClientBilling from 'src/models/ClientBilling';
// import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';

const ManageClientBilling = () => {
    const { register, handleSubmit, errors, reset } = useForm();
    // const dispatch = useDispatch();
    const { get, response, post, put } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const [clientBillingData, setClientBillingData] = useState<ClientBilling>(undefined);

    const [formData, setFormData] = useState(null);
    const [billingFrequency, setBillingFrequency] = useState(false);
    // const wipCurrentValue = useRef();

    useEffect(() => {
        getClientBillingData();
    }, []);

    useEffect(() => {
        prepFormData();
    }, [clientBillingData]);

    useEffect(() => {
        reset(formData);
    }, [formData]);

    const getClientBillingData = async () => {
        const result = await get(`/v1.0/Clients/client-billing/${appContext.clientNumber}`);
        // const result = await get('/');

        if (response.ok) {
            console.log('Client Billing Data', result);
            setClientBillingData(result);
        }
    };

    const prepFormData = () => {
        let data: ClientBilling = {
            id: clientBillingData ? clientBillingData?.id : 0,
            defaultDayRate: clientBillingData ? clientBillingData?.defaultDayRate : 0,
            mileageRate: clientBillingData ? clientBillingData?.mileageRate : 0,
            invoicePeriod: clientBillingData ? clientBillingData?.invoicePeriod : '',
            billBy: clientBillingData ? clientBillingData?.billBy : '',
            chargeBackupPersonnel: clientBillingData ? clientBillingData?.chargeBackupPersonnel : false,
            chargeTsdiOfficeExpenses: clientBillingData ? clientBillingData?.chargeTsdiOfficeExpenses : false,
            flatDayRate: clientBillingData ? clientBillingData?.flatDayRate : false,
            chargeBackupPersonnelAtCost: clientBillingData ? clientBillingData?.chargeBackupPersonnelAtCost : false,
            backUpOfficeRate: clientBillingData ? clientBillingData?.backUpOfficeRate : false,
            backUpOfficePercent: clientBillingData ? clientBillingData?.backUpOfficePercent : false,
            printPreparedDate: clientBillingData ? clientBillingData?.printPreparedDate : false,
            bopNameOnInvoice: clientBillingData ? clientBillingData?.bopNameOnInvoice : false,
            arInvoiceWipProject: clientBillingData ? clientBillingData?.arInvoiceWipProject : false,
            unityEntryRequired: clientBillingData ? clientBillingData?.unityEntryRequired : false,
            clientProspectNameOnTimeSheet: clientBillingData ? clientBillingData?.clientProspectNameOnTimeSheet : false,
            clientProspectNoOnTimeSheet: clientBillingData ? clientBillingData?.clientProspectNoOnTimeSheet : false,
            doNotExceedProject: clientBillingData ? clientBillingData?.doNotExceedProject : false,
            totalAFEWarning: clientBillingData ? clientBillingData?.totalAFEWarning : 0,
            afeStatus: clientBillingData ? clientBillingData?.afeStatus : false,
            billingFrequency: clientBillingData ? clientBillingData?.billingFrequency : '',
            billingInstruction: clientBillingData ? clientBillingData?.billingInstruction : '',
        };

        if (data.arInvoiceWipProject) {
            setBillingFrequency(data.arInvoiceWipProject);
        }

        setFormData(data);
    };

    const createRecord = async (data: ClientBilling) => {
        console.log('client billing data', data);

        const result = await post(`/v1.0/Clients/client-billing/${appContext.clientNumber}`, data);

        if (response.ok) {
            console.log('Successfully creating a billing record', result);
        }
    };

    const updateRecord = async (data: ClientBilling) => {
        const result = await put(`/v1.0/Clients/client-billing/${appContext.clientNumber}`, data);

        if (response.ok) {
            console.log('result', result);
            getClientBillingData();
        }
    };

    const wipProjectSelected = (event: AnyObject) => {
        let projectChecked = event.target.checked;

        setBillingFrequency(projectChecked);
    };

    const formatData = (values: AnyObject) => {
        let newValues: ClientBilling = {
            id: 0,
            defaultDayRate: 0,
            mileageRate: 0,
            invoicePeriod: '',
            billBy: '',
            chargeBackupPersonnel: false,
            chargeTsdiOfficeExpenses: false,
            flatDayRate: false,
            chargeBackupPersonnelAtCost: false,
            backUpOfficeRate: false,
            backUpOfficePercent: false,
            printPreparedDate: false,
            bopNameOnInvoice: false,
            arInvoiceWipProject: false,
            unityEntryRequired: false,
            clientProspectNameOnTimeSheet: false,
            clientProspectNoOnTimeSheet: false,
            doNotExceedProject: false,
            totalAFEWarning: 0,
            afeStatus: false,
            billingFrequency: '',
            billingInstruction: '',
        };

        newValues.id = clientBillingData.id ? parseInt(clientBillingData.id + '', 10) : 0;
        newValues.defaultDayRate = values.defaultDayRate ? parseFloat(values.defaultDayRate + '') : 0;
        newValues.totalAFEWarning = values.totalAFEWarning ? parseInt(values.totalAFEWarning + '', 10) : 0;
        newValues.mileageRate = values.mileageRate ? parseInt(values.mileageRate + '', 10) : 0;
        newValues.invoicePeriod = values.invoicePeriod ? values.invoicePeriod : '';
        newValues.billBy = values.billBy ? values.billBy : '';
        newValues.billingFrequency = values.billingFrequency ? values.billingFrequency : '';
        newValues.chargeBackupPersonnel = !!values.chargeBackupPersonnel ? values.chargeBackupPersonnel : null;
        newValues.chargeBackupPersonnelAtCost = !!values.chargeBackupPersonnelAtCost ? values.chargeBackupPersonnelAtCost : null;
        newValues.flatDayRate = !!values.flatDayRate ? values.flatDayRate : null;
        newValues.chargeTsdiOfficeExpenses = !!values.chargeTsdiOfficeExpenses ? values.chargeTsdiOfficeExpenses : null;
        newValues.backUpOfficeRate = !!values.backUpOfficeRate ? values?.backUpOfficeRate : null;
        newValues.backUpOfficePercent = !!values.backUpOfficePercent ? values?.backUpOfficePercent : null;
        newValues.printPreparedDate = !!values.printPreparedDate ? values.printPreparedDate : null;
        newValues.bopNameOnInvoice = !!values.bopNameOnInvoice ? values?.bopNameOnInvoice : null;
        newValues.arInvoiceWipProject = !!values.arInvoiceWipProject ? values.arInvoiceWipProject : null;
        newValues.unityEntryRequired = !!values.unityEntryRequired ? values?.unityEntryRequired : null;
        newValues.clientProspectNameOnTimeSheet = !!values.clientProspectNameOnTimeSheet ? values.clientProspectNameOnTimeSheet : null;
        newValues.clientProspectNoOnTimeSheet = !!values.clientProspectNoOnTimeSheet ? values.clientProspectNoOnTimeSheet : null;
        newValues.doNotExceedProject = !!values.doNotExceedProject ? values.doNotExceedProject : null;
        newValues.afeStatus = !!values.afeStatus ? values.afeStatus : null;
        newValues.billingInstruction = values.billingInstruction ? values.billingInstruction : '';

        return newValues;
    };

    const onSubmit = (values: AnyObject) => {
        console.log('🤯 ~ file: ManageClientBilling.tsx:162 ~ onSubmit ~ values:', values);

        let newValues = formatData(values);
        console.log('🤯 ~ file: ManageClientBilling.tsx:165 ~ onSubmit ~ newValues:', newValues);

        if (!clientBillingData.id || clientBillingData.id === 0) {
            createRecord(newValues);
        } else {
            updateRecord(newValues);
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <RHFLegend title="Client Billing" />
                    <div className="flex-space__between mrg-btm" style={{ alignItems: 'center' }}>
                        <div className="flex-wrap half-width">
                            <div className="input-resize">
                                <RHFInputBox name="defaultDayRate" label="Default Day Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFInputBox name="mileageRate" label="Mileage Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Invoice Period"
                                    name="invoicePeriod"
                                    options={[
                                        { value: 'semiMonthly', label: 'Semi-Monthly' },
                                        { value: 'monthly', label: 'Monthly' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Bill By"
                                    name="billBy"
                                    options={[
                                        { value: 'dayProspect', label: 'Day/Prospect' },
                                        { value: 'weekProspect', label: 'Week/Prospect' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ borderTop: '1px solid grey', borderBottom: '1px solid grey' }}>
                        <div className="mrg-top mrg-btm">
                            <RHFTextArea label="Billing Instructions" name="billingInstruction" register={register} errors={errors} />
                        </div>
                    </div>
                    <div className="flex mrg-top mrg-btm">
                        <FormRow className="flex-column flex-space__between" style={{ marginTop: '0' }}>
                            <div className="flex-gap">
                                <input type="checkbox" name="chargeBackupPersonnel" ref={register} />
                                <label htmlFor="chargeBackupPersonnel">Charge Backup Personnel?</label>
                            </div>
                            <div className="flex-gap">
                                <input type="checkbox" name="chargeTsdiOfficeExpenses" ref={register} />
                                <label htmlFor="chargeTsdiOfficeExpenses">Charge TSDI Office Expenses?</label>
                            </div>
                            <div className="flex-gap">
                                <input type="checkbox" name="flatDayRate" ref={register} />
                                <label htmlFor="flatDayRate">Flat Day Rate (No Expenses)?</label>
                            </div>
                            {/* <div className="flex-gap">
                                <input type="checkbox" name="clientLmEmailonInvoice" ref={register} />
                                <label htmlFor="clientLmEmailonInvoice">Client LM E-mail on Invoice?</label>
                            </div> */}
                        </FormRow>
                        <FormRow className="flex-column flex-space__between">
                            {/* <div className="flex-gap">
                                <input type="checkbox" name="mileageDestinationRequired" ref={register} />
                                <label htmlFor="mileageDestinationRequired">Milage Destination Required?</label>
                            </div> */}
                            <div className="flex-gap">
                                <input type="checkbox" name="chargeBackupPersonnelAtCost" ref={register} />
                                <label htmlFor="chargeBackupPersonnelAtCost">Charge Backup Personnel at Cost?</label>
                            </div>
                            <div className="flex-gap">
                                <input type="checkbox" name="backUpOfficeRate" ref={register} />
                                <label htmlFor="backupOfficeRate">Backup/Office Rate</label>
                            </div>
                            <div className="flex-gap">
                                <input type="checkbox" name="backUpOfficePercent" ref={register} />
                                <label htmlFor="backupOfficePercent">Backup/Office Percent</label>
                            </div>
                        </FormRow>
                        <FormRow className="flex-column flex-space__between">
                            <div className="flex-gap">
                                <input type="checkbox" name="printPreparedDate" ref={register} />
                                <label htmlFor="printPreparedDate">Print Prepared Date?</label>
                            </div>
                            <div className="flex-gap">
                                <input type="checkbox" name="bopNameOnInvoice" ref={register} />
                                <label htmlFor="bopNamenOnInvoice">BOP Name on Invoice?</label>
                            </div>
                            <div className="flex-gap">
                                <input type="checkbox" name="unityEntryRequired" ref={register} />
                                <label htmlFor="unityEntryRequired">Unit Entry Required?</label>
                            </div>
                        </FormRow>
                        <FormRow className="flex-column flex-space__between">
                            <div className="flex-gap">
                                <input type="checkbox" name="clientProspectNoOnTimeSheet" ref={register} />
                                <label htmlFor="clientProspectNoOnTimeSheet">Enter Client Prospect No. on Time Sheet?</label>
                            </div>
                            <div className="flex-gap">
                                <input type="checkbox" name="clientProspectNameOnTimeSheet" ref={register} />
                                <label htmlFor="clientProspectNameOnTimeSheet">Enter Client Prospect Name on Time Sheet?</label>
                            </div>
                            <div className="flex-gap">
                                <input type="checkbox" name="arInvoiceWipProject" ref={register} onClick={wipProjectSelected} />
                                <label htmlFor="arInvoiceWipProject"> WIP Project?</label>
                            </div>
                            {/* <div className="flex-gap">
                                <input type="checkbox" name="turnKeyBilling" ref={register} />
                                <label htmlFor="turnKeyBilling">Turnkey Billing?</label>
                            </div> */}
                        </FormRow>
                    </div>
                    <FormRow className="mrg-top flex flex-space__between" style={{ borderTop: '1px solid grey' }}>
                        <div className="flex-gap ">
                            <input type="checkbox" name="doNotExceedProject" ref={register} />
                            <label htmlFor="doNotExceedProject">Do Not Exceed Project?</label>
                        </div>
                        <div className="input-resize">
                            <RHFInputBox name="totalAFEWarning" label="Total AFE Warning %" register={register} errors={errors} />
                        </div>
                        <div className="flex-gap">
                            <input type="checkbox" name="afeStatus" ref={register} />
                            <label htmlFor="afeStatus">AFE Status on Invoice/Cover?</label>
                        </div>
                        {!!billingFrequency && (
                            <div className="input-resize">
                                <RHFSelect
                                    label="Billing Frequency"
                                    name="billingFrequency"
                                    options={[
                                        { value: 'semiMonthly', label: 'Semi-Monthly' },
                                        { value: 'monthly', label: 'Monthly' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                        )}
                    </FormRow>
                </div>

                <div className="mrg-top">
                    <Button text="Submit" intent="primary" type="submit" />
                </div>
            </form>
        </div>
    );
};

export default ManageClientBilling;



// WEBPACK FOOTER //
// ./src/components/project/sections/ManageClientBilling.tsx